import React from 'react'
import {Checkbox} from 'antd'
import {useState, useEffect} from 'react'
import {Upload, message, Button, Row, Col, Tooltip, Modal} from 'antd'
import {UploadOutlined, InboxOutlined} from '@ant-design/icons'
import {Spin} from 'antd'
import Layouts from '../src/components/Layouts'
import axios from 'axios'
import DocViewer from 'react-doc-viewer'
import {DownloadOutlined, InfoCircleOutlined} from '@ant-design/icons'
import {saveAs} from 'file-saver'
import ViewPolicyClaim from './ViewPolicy'
import apiRequest from './hooks/apiRequest'
export default function DocumentUploader() {
  const [claimData, setClaimData] = useState()
  const [loading, setLoading] = useState(true)
  const [selectedFile, setSelectedFile] = useState()
  const [selectedQuotationFile, setSelectedQuotationFile] = useState()
  const [selectedPoliceFile, setSelectedPoliceFile] = useState()
  const [uploadedDoc, setUploadedDoc] = useState([])
  const [viewPolicy, setViewPolicy] = useState(false)
  const [doc, setDoc] = useState()
  const [policyData, setPolicyData] = useState()
  useEffect(() => {
    const fetchClaimData = async () => {
      try {
        const claimId = localStorage.getItem('claimId');
        const claimRes = await apiRequest(
          process.env.REACT_APP_BASE_URL + '/claim/GetClaims/' + claimId,
          'GET'
        );
        setClaimData(claimRes?.data?.result[0]?.claim_creation);
        const quotationRes = await apiRequest(
          process.env.REACT_APP_BASE_URL + '/claim/GetClaimQuotation/' + claimId,
          'GET'
        ); 
        console.log('quotationRes',quotationRes?.data)
        setUploadedDoc(quotationRes?.data);
      } catch (error) {
        console.error('Error fetching claim data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchClaimData();
  }, []);
  
console.log('uploadedDoc',uploadedDoc)
  function onFileChangeDriver(event) {
    setSelectedFile(event.target.files[0])
  }
  function onFileChangeQuotation(event) {
    setSelectedQuotationFile(event.target.files[0])
  }
  function onFileChangePolice(event) {
    setSelectedPoliceFile(event.target.files[0])
  }

  async function onFileUploadDriver() {
    const file = new FormData();
    file.append('claim_id', parseInt(localStorage.getItem('claimId')));
    file.append('claim_number', claimData.claim_number);
    file.append('policy_number', claimData.policy_number);
    file.append('filename', 'Drivers License');
    file.append('FormFile', selectedFile);
    file.append('doc_path', 'mmjjkk');
  
    try {
      const response = await apiRequest(
        process.env.REACT_APP_BASE_URL + '/Claim/ClaimDocuments',
        'POST',
        file,
        true // indicates it's a FormData request
      );
  
      if (response.status === 201) {
        message.success('Driver Licence uploaded successfully');
      } else {
        message.error('Driver Licence upload Failed');
      }
  
      window.location.reload();
    } catch (error) {
      console.error('Upload failed:', error);
      message.error('Something went wrong while uploading.');
    }
  }
  

  async function onFileUploadQuotation() {
    const file = new FormData();
    file.append('claim_id', parseInt(localStorage.getItem('claimId')));
    file.append('claim_number', claimData.claim_number);
    file.append('policy_number', claimData.policy_number);
    file.append('filename', 'Quotation File');
    file.append('FormFile', selectedQuotationFile);
    file.append('doc_path', 'mmjjkk');
  
    try {
      const response = await apiRequest(
        process.env.REACT_APP_BASE_URL + '/Claim/ClaimDocuments',
        'POST',
        file,
        true
      );
  
      if (response.status === 201) {
        message.success('Quotation uploaded successfully');
      } else {
        message.error('Quotation upload Failed');
      }
  
      window.location.reload();
    } catch (error) {
      console.error('Quotation upload failed:', error);
      message.error('Something went wrong while uploading.');
    }
  }
  

  async function onFileUploadPolice() {
    const file = new FormData();
    file.append('claim_id', parseInt(localStorage.getItem('claimId')));
    file.append('claim_number', claimData.claim_number);
    file.append('policy_number', claimData.policy_number);
    file.append('filename', 'Police File');
    file.append('FormFile', selectedPoliceFile);
    file.append('doc_path', 'mmjjkk');
  
    try {
      const response = await apiRequest(
        process.env.REACT_APP_BASE_URL + '/Claim/ClaimDocuments',
        'POST',
        file,
        true
      );
  
      if (response.status === 201) {
        message.success('Police Document uploaded successfully');
      } else {
        message.error('Police Document upload Failed');
      }
  
      window.location.reload();
    } catch (error) {
      console.error('Police document upload failed:', error);
      message.error('Something went wrong while uploading.');
    }
  }
  

  async function postData() {
    if (claimData.accessor_id !== 0 && claimData.accessor_name !== null) {
      const payload = {
        ...claimData,
        claim_status: 'Assessment',
        user_name: localStorage.getItem('username'),
        user_id: localStorage.getItem('loggedInUserID')
      };
  
      try {
        const response = await apiRequest(
          process.env.REACT_APP_BASE_URL + '/claim/CreateClaim',
          'POST',
          payload
        );
  
        if (response.success) {
          window.location.reload();
        } else {
          message.error('Failed to update claim');
          console.error('API error:', response.error || response.data);
        }
      } catch (error) {
        console.error('Request failed:', error);
        message.error('Something went wrong');
      }
    } else {
      message.warning('Kindly assign Assessor to change status to Assessment');
    }
  }
  

  function downloadFile(val) {
    saveAs(val, 'Claim Uploaded Document')
  }

  function ViewPolicyF(val) {
    let apiData
    var productId

    setLoading(true)
    if (val.includes('OTM')) {
      fetch('http://64.227.72.205:5001/api/v1/policy/' + val)
        .then(res => res.json())
        .then(data => {
          apiData = {
            productName: 'Motor Insurance',
            policyNo: data.policy_number,
            policyStartDate: data.policy_start_date,
            policyEndDate: data.policy_end_date,
            sumInsured: data.sum_insured,
            customerName: data.first_name + ' ' + data.surname,
            riskItemDetails: '',
            vrn: data.vrn,
          }
          setLoading(false)
          setPolicyData(apiData)
        })
    } else {
      if (val.includes('OTAAR')) {
        productId = 1
      } else if (val.includes('OTDC')) {
        productId = 2
      } else if (val.includes('OTFCP')) {
        productId = 3
      }
      fetch(
        process.env.REACT_APP_BASE_URL_POLICIES +
          //process.env.REACT_APP_BASE_URL +
          '/Policy/GetPolicybynumber/' +
          val +
          ',' +
          productId,
      )
        .then(res => res.json())
        .then(data => {
          apiData = {
            productName: data.policydetail.productname,
            policyNo: data.policydetail.policynumber,
            policyStartDate: data.policydetail.policystartdate,
            policyEndDate: data.policydetail.policyexpirytdate,
            sumInsured: '',
            customerName: data.policydetail.customername,
            riskItemDetails: data.policydetail.riskitemdetails,
          }
          setLoading(false)
          setPolicyData(apiData)
        })
    }
    setViewPolicy(true)
  }

  function setVisibleFalse() {
    setViewPolicy(false)
  }

  return (
    <>
      <Layouts title="assets" classname="grid">
        <Spin
          className="loader-icon-fixed"
          spinning={loading}
          size="large"></Spin>
        <div className=" dash-bg-white">
          <Row gutter={4}>
            <Col xs={12} sm={24} md={12} lg={24}>
              <h2
                style={{
                  color: '#F15A2B',
                  fontWeight: '500',
                  fontSize: '20px',
                  marginBottom: '0',
                }}>
                {claimData && claimData.claim_status !== 'Assessment' && (
                  <strong>
                    Claim Details{' '}
                    <label
                      style={{
                        color: '#F15A2B',
                        fontWeight: '700',
                        fontSize: '20px',
                      }}></label>
                  </strong>
                )}
                {claimData && claimData.claim_status === 'Assessment' && (
                  <strong>
                    Claim Details{' '}
                    <label
                      style={{
                        color: '#F15A2B',
                        fontWeight: '700',
                        fontSize: '20px',
                      }}></label>
                  </strong>
                )}
              </h2>
            </Col>
          </Row>
          <Row gutter={[16, 24]} style={{display: 'inline'}}>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>Customer Name : </b> {claimData && claimData.customer_name}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>Claim No. : </b> {claimData && claimData.claim_number}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>Policy No. : </b>
                {claimData && claimData.policy_number}
              </label>
              <Tooltip title="View Policy Details">
                <InfoCircleOutlined
                  style={{
                    position: 'relative',
                    zIndex: '999',
                    marginLeft: '10px',
                    color: '#29b0e5',
                  }}
                  onClick={() => ViewPolicyF(claimData.policy_number)}
                />
              </Tooltip>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b> Date of Loss : </b>
                {claimData && claimData.date_of_loss}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b> Date of Notification :</b>{' '}
                {claimData && claimData.date_of_notification}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>Claim Amount : </b>
                {claimData && claimData.claim_amount}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>Claim Status : </b>
                {claimData && claimData.claim_status}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b>Assigned To : </b>
                {claimData && claimData.accessor_name}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b> Item Detail :</b> {claimData && claimData.itemdetails}
              </label>
            </Col>
            <Col xs={24} md={12} lg={6}>
              <label>
                <b> Approved Amount :</b>{' '}
                {claimData && claimData.approved_amount}
              </label>
            </Col>
            <Col xs={24} md={12} lg={12}>
              <label>
                <b> Damage Description :</b>{' '}
                {claimData && claimData.damage_description}
              </label>
            </Col>
          </Row>
        </div>
        <div className="dash-bg-white">
          <Row>
            <Col xs={24} md={12} lg={12}>
              <div className="dash-bg-white" style={{marginRight: '15px'}}>
                <div className="section-top-heading">
                  <h3
                    style={{
                      color: '#F15A2B',
                      fontWeight: '700',
                      fontSize: '20px',
                      margin: '0',
                      marginBottom: '20px',
                    }}>
                    {' '}
                    Police Report{' '}
                  </h3>
                </div>
                {uploadedDoc.length !== 0 && (
                  <div>
                    <ul>
                      {uploadedDoc?.map(uploadedDocs => {
                        return (
                          <div>
                            {uploadedDocs.filename === 'Police File' && (
                              <label>
                                <b>
                                  {uploadedDocs.doc_path.slice(40)}
                                  &nbsp;&nbsp; <b>Created on :</b>&nbsp;
                                  {uploadedDocs.created_date.slice(0, -16)}
                                  &nbsp;&nbsp;&nbsp;
                                  <Tooltip title="Download Document">
                                    <DownloadOutlined
                                      style={{color: 'green'}}
                                      onClick={() =>
                                        downloadFile(uploadedDocs.doc_path)
                                      }
                                    />
                                  </Tooltip>
                                </b>
                              </label>
                            )}
                          </div>
                        )
                      })}
                    </ul>
                  </div>
                )}
                {localStorage.getItem('userType') !== 'CLAIMS_ACCESSOR' && (
                  <input type="file" onChange={onFileChangePolice} />
                )}{' '}
                {localStorage.getItem('userType') !== 'CLAIMS_ACCESSOR' && (
                  <div style={{textAlign: 'end'}}>
                    {claimData &&
                      claimData.claim_status !== 'Awaiting Authorisation' && (
                        <button
                          style={{width: '250px'}}
                          htmlType="submit"
                          size="default"
                          className="primary m-t-0 w-50"
                          onClick={onFileUploadPolice}>
                          Upload
                        </button>
                      )}
                  </div>
                )}
              </div>
            </Col>
            <Col xs={24} md={12} lg={12}>
              <div className="dash-bg-white" style={{marginRight: '15px'}}>
                <div className="section-top-heading">
                  <h3
                    style={{
                      color: '#F15A2B',
                      fontWeight: '700',
                      fontSize: '20px',
                      margin: '0',
                      marginBottom: '20px',
                    }}>
                    {' '}
                    Quotations{' '}
                  </h3>
                </div>
                {uploadedDoc.length !== 0 && (
                  <div>
                    <ul>
                      {uploadedDoc?.map(uploadedDocs => {
                        return (
                          <div>
                            {uploadedDocs.filename === 'Quotation File' && (
                              <label>
                                <b>
                                  {uploadedDocs.doc_path.slice(40)}
                                  &nbsp;&nbsp; <b>Created on :</b>&nbsp;
                                  {uploadedDocs.created_date.slice(0, -16)}
                                  &nbsp;&nbsp;&nbsp;
                                  <Tooltip title="Download Document">
                                    <DownloadOutlined
                                      style={{color: 'green'}}
                                      onClick={() =>
                                        downloadFile(uploadedDocs.doc_path)
                                      }
                                    />
                                  </Tooltip>
                                </b>
                              </label>
                            )}
                          </div>
                        )
                      })}
                    </ul>
                  </div>
                )}
                {localStorage.getItem('userType') !== 'CLAIMS_ACCESSOR' && (
                  <input type="file" onChange={onFileChangeQuotation} />
                )}{' '}
                {localStorage.getItem('userType') !== 'CLAIMS_ACCESSOR' && (
                  <div style={{textAlign: 'end'}}>
                    {claimData &&
                      claimData.claim_status !== 'Awaiting Authorisation' && (
                        <button
                          style={{width: '250px'}}
                          htmlType="submit"
                          size="default"
                          className="primary m-t-0 w-50"
                          onClick={onFileUploadQuotation}>
                          Upload
                        </button>
                      )}
                  </div>
                )}
              </div>
            </Col>
          </Row>
          {claimData && claimData.policy_number.includes('OTM') && (
            <Row>
              <Col xs={24} md={12} lg={12}>
                <div className="dash-bg-white" style={{marginRight: '15px'}}>
                  <Col xs={24} sm={24} md={24} lg={24}>
                    <div className="section-top-heading">
                      <h3
                        style={{
                          color: '#F15A2B',
                          fontWeight: '700',
                          fontSize: '20px',
                          margin: '0',
                          marginBottom: '20px',
                        }}>
                        {' '}
                        Copy of Drivers Licence{' '}
                      </h3>
                    </div>
                  </Col>
                  {uploadedDoc.length !== 0 && (
                    <div>
                      <ul>
                        {uploadedDoc?.map(uploadedDocs => {
                          return (
                            <div>
                              {uploadedDocs.filename === 'Drivers License' && (
                                <label>
                                  <b>
                                    {uploadedDocs.doc_path.slice(40)}
                                    &nbsp;&nbsp; <b>Created on :</b>&nbsp;
                                    {uploadedDocs.created_date.slice(0, -16)}
                                    &nbsp;&nbsp;&nbsp;
                                    <Tooltip title="Download Document">
                                      <DownloadOutlined
                                        style={{color: 'green'}}
                                        onClick={() =>
                                          downloadFile(uploadedDocs.doc_path)
                                        }
                                      />
                                    </Tooltip>
                                  </b>
                                </label>
                              )}
                            </div>
                          )
                        })}
                      </ul>
                    </div>
                  )}
                  <Col xs={24} sm={24} md={24} lg={24}>
                    {localStorage.getItem('userType') !== 'CLAIMS_ACCESSOR' && (
                      <input type="file" onChange={onFileChangeDriver} />
                    )}{' '}
                    {localStorage.getItem('userType') !== 'CLAIMS_ACCESSOR' && (
                      <div style={{textAlign: 'end'}}>
                        {claimData &&
                          claimData.claim_status !==
                            'Awaiting Authorisation' && (
                            <button
                              style={{width: '250px'}}
                              htmlType="submit"
                              size="default"
                              className="primary m-t-0 w-50"
                              onClick={onFileUploadDriver}>
                              Upload
                            </button>
                          )}
                      </div>
                    )}
                  </Col>
                </div>
              </Col>
            </Row>
          )}
          {uploadedDoc.length === 0 &&
            localStorage.getItem('userType') !== 'CLAIMS_ACCESSOR' && (
              <div style={{textAlign: 'right', paddingRight: '15px'}}>
                <Tooltip title="Upload related documents and assign Assessor to submit">
                  <button
                    style={{
                      backgroundColor: '#40a9ffc2',
                      padding: '8px 24px',
                      border: '2px solid #40a9ffc2',
                      borderRadius: '4px',
                      fontSize: '16px',
                      color: '#333',
                      fontWeight: '800',
                    }}
                    disabled>
                    Submit
                  </button>
                </Tooltip>
              </div>
            )}
          {uploadedDoc.length !== 0 &&
            localStorage.getItem('userType') !== 'CLAIMS_ACCESSOR' && (
              <div style={{textAlign: 'right', paddingRight: '15px'}}>
                <button
                  onClick={postData}
                  style={{
                    backgroundColor: '#40a9ffc2',
                    padding: '8px 24px',
                    border: '2px solid #40a9ffc2',
                    borderRadius: '4px',
                    fontSize: '16px',
                    color: '#333',
                    fontWeight: '800',
                  }}>
                  Submit
                </button>
              </div>
            )}
        </div>
        <Modal
          title="Details"
          centered
          visible={viewPolicy}
          footer={null}
          onCancel={setVisibleFalse}
          width={1200}>
          <ViewPolicyClaim parentToChild={policyData} />
        </Modal>
      </Layouts>
    </>
  )
}
